import { OriginRelaySymbol } from "@/components/icons/OriginRelaySymbol"
import { StepFormLayout, ContinueButton } from "./primitives"

interface WelcomeStepProps {
  onContinue: () => void
  /** Whether this is an existing user updating settings */
  isExistingUser?: boolean
  /** Whether the app is loading (e.g., checking Git Bash on Windows) */
  isLoading?: boolean
}

/**
 * WelcomeStep - Initial welcome screen for onboarding
 *
 * Shows different messaging for new vs existing users:
 * - New users: Welcome to Origin Relay
 * - Existing users: Update your API connection settings
 */
export function WelcomeStep({
  onContinue,
  isExistingUser = false,
  isLoading = false
}: WelcomeStepProps) {
  return (
    <StepFormLayout
      iconElement={
        <div className="flex size-16 items-center justify-center">
          <OriginRelaySymbol className="size-10 text-foreground" />
        </div>
      }
      title={isExistingUser ? 'Update Settings' : 'Welcome to Origin Relay'}
      description={
        isExistingUser
          ? 'Update your API connection or change your setup.'
          : 'Your unfair advantage at Origin. Already connected to our systems, trained on our playbook — ready to help you do your best work.'
      }
      actions={
        <ContinueButton onClick={onContinue} className="w-full" loading={isLoading} loadingText="Checking...">
          {isExistingUser ? 'Continue' : 'Get Started'}
        </ContinueButton>
      }
    />
  )
}
